import React, { useEffect, useState } from 'react';
import { Table, Spin, message, Input, Tag, Select, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const { Option } = Select;

const periodosMap = {
  dia: 1,
  semana: 7,
  mes: 30,
  semestre: 180,
  ano: 365
};

const RelatorioSugestaoCompra = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [periodo, setPeriodo] = useState('mes'); // padrão Mês
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    fetchRelatorio();
  }, []);

  const fetchRelatorio = async (periodoKey = periodo) => {
    setLoading(true);
    try {
      const dias = periodosMap[periodoKey];
      const response = await axios.get(`/api/relatorios/sugestao-compra?periodo=${dias}`);
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.error(error);
      message.error('Erro ao carregar relatório.');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = data.filter(prod =>
      prod.NOME.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const gerarPdf = () => {
  const doc = new jsPDF();

  const produtosComprar = filteredData.filter(prod => (prod.pedido_minimo_mes - prod.estoque_atual) > 0);

  if (produtosComprar.length === 0) {
    message.info('Não há produtos a serem comprados hoje.');
    return;
  }

  const tableColumn = ["Produto", "Estoque Atual", "Pedido Mínimo Mês", "Quantidade a Comprar"];
  const tableRows = produtosComprar.map(prod => [
    prod.NOME,
    prod.estoque_atual,
    prod.pedido_minimo_mes,
    prod.pedido_minimo_mes - prod.estoque_atual
  ]);

  doc.text("Relatório de Produtos a Comprar", 14, 15);

  autoTable(doc, { // <- aqui
    head: [tableColumn],
    body: tableRows,
    startY: 20,
  });

  doc.save(`relatorio_compras_${new Date().toISOString().slice(0,10)}.pdf`);
};

  const columns = [
    { title: 'Produto', dataIndex: 'NOME', key: 'produto' },
    { title: 'Estoque Atual', dataIndex: 'estoque_atual', key: 'estoque_atual' },
    { title: 'Estoque Mínimo', dataIndex: 'estoque_minimo', key: 'estoque_minimo' },
    { title: 'Total Vendido', dataIndex: 'total_vendido', key: 'total_vendido' },
    { 
      title: 'Pedido Mínimo Mês', 
      dataIndex: 'pedido_minimo_mes', 
      key: 'pedido_minimo_mes'
    },
    {
      title: 'Quantidade a Comprar',
      key: 'quantidade_comprar',
      render: (_, record) => {
        const necessario = record.pedido_minimo_mes - record.estoque_atual;
        const valor = necessario > 0 ? necessario : 0;
        return <Tag color={valor > 0 ? 'red' : 'green'}>{valor}</Tag>;
      }
    }
  ];

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '50px auto' }} />;

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
        <Input
          placeholder="Buscar produto..."
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
          size="large"
        />

        <Select
          value={periodo}
          onChange={setPeriodo}
          style={{ width: 150 }}
          size="large"
        >
          <Option value="dia">Dia</Option>
          <Option value="semana">Semana</Option>
          <Option value="mes">Mês</Option>
          <Option value="semestre">Semestre</Option>
          <Option value="ano">Ano</Option>
        </Select>

        <Button style={{ width: 200 }} size="large" type="primary" onClick={() => fetchRelatorio(periodo)}>Filtrar</Button>
        <Button style={{ width: 200 }} size="large" type="default" onClick={() => navigate('/produtos')}>Produtos</Button>
        <Button style={{ width: 200 }} size="large" type="default" onClick={() => navigate('/estoque')}>Estoque</Button>
        <Button style={{ width: 200 }} size="large" type="primary" onClick={gerarPdf}>Gerar PDF</Button>
      </div>

      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="ID_PRODUTO"
        pagination={{ pageSize: 10 }}
        bordered
      />
    </>
  );
};

export default RelatorioSugestaoCompra;
